(function () {
  'use strict';

  const observed = new WeakSet();
  const copy = 'Save 25% today, 5% off future orders.';

  function initialize() {
    document.querySelectorAll('recharge-subscription-widget').forEach(widget => {
      const root = widget.shadowRoot;
      if (!root || observed.has(root)) return;
      observed.add(root);

      const update = () => {
        const badge = root.querySelector('[part~="rc-purchase-option__badge"]');
        if (badge && badge.textContent !== copy) badge.textContent = copy;
      };
      new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
      update();
    });
  }

  customElements.whenDefined('recharge-subscription-widget').then(initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
